function fireGa(eventName) {
  const eventProps = {
    'category': this.props.gaCategory,
    'id': this.getGaAttribute('id'),
    'title': this.getGaAttribute('title'),
    'program': this.getGaAttribute('program')
  }
  window.gtag('event', eventName, eventProps)
  if(window.fbq) {
    window.fbq('trackCustom', eventName, eventProps)
  }
}

export default fireGa;